import React from "react";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

export default function RegularInput(props: {
  form: any;
  name: string;
  label?: string;
  isEditable: boolean;
  extraClass?: string;
  type?: string;
  placeholder?: string;
}) {
  const extraClass = props.extraClass || "";
  const type = props.type || "text";

  return (
    <FormField
      control={props.form.control}
      name={props.name}
      render={({ field }) => (
        <FormItem className="pt-4">
          <FormLabel className="font-semibold flex items-center">{props.label}</FormLabel>
          <FormControl>
            <Input
              {...field}
              placeholder={props.placeholder}
              type={type}
              readOnly={!props.isEditable}
              className={
                props.isEditable
                  ? `w-full text-base bg-transparent ${extraClass}`
                  : `w-full text-base bg-slate-200 ${extraClass}`
              }
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
